import type { Ref } from "vue";
import type {
  ProcessedCommentaryComment,
  ProcessedCommentaryImage,
} from "./processCommentarySearchResults/types";

export function useCommentarySearchResultsPosition(
  nid: Ref<number>,
  flatResults: Ref<(ProcessedCommentaryComment | ProcessedCommentaryImage)[]>,
) {
  /**
   * The index of the current comment in the `flatResultsCommentsOnly` array.
   */
  const positionInResults = computed<number>(() => {
    return flatResults.value.findIndex((data) => data.nid === unref(nid));
  });

  /**
   * The next result, if the comment is from a list of search results.
   */
  const nextResult = computed<
    ProcessedCommentaryComment | ProcessedCommentaryImage | undefined
  >(() => {
    if (positionInResults.value < 0) {
      return;
    }

    return flatResults.value[positionInResults.value + 1];
  });

  /**
   * The previous result, if the comment is from a list of search results.
   */
  const previousResult = computed<
    ProcessedCommentaryComment | ProcessedCommentaryImage | undefined
  >(() => {
    if (positionInResults.value < 0) {
      return;
    }

    return flatResults.value[positionInResults.value - 1];
  });

  return {
    positionInResults,
    nextResult,
    previousResult,
  };
}
